import { motion } from "framer-motion";
import { useState } from "react";

export default function Nav({ buttons }) {
  const [active, setActive] = useState(0);

  return (
    <motion.nav
      initial={{ opacity: 0, y: -40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className="text-slate-300 text-sm font-black z-50 mx-auto max-w-96 fixed inset-x-0 top-2 h-12 rounded-xl backdrop-sepia bg-white/10 backdrop-blur-lg flex justify-evenly items-center"
    >
      {buttons.map((button, index) => (
        <div key={index} className="relative">
          <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => {
              setActive(index);
              button.ref.current.scrollIntoView({ behavior: "smooth" });
            }}
            className={`transition-colors duration-300 ${
              active === index ? "text-slate-600" : "hover:text-slate-600"
            }`}
          >
            {button.value}
          </motion.button>

          {/* Animated underline */}
          {active === index && (
            <motion.div
              layoutId="underline"
              className="absolute left-0 right-0 -bottom-1 h-[2px] bg-slate-600 rounded"
            />
          )}
        </div>
      ))}
    </motion.nav>
  );
}
